import { render, staticRenderFns } from "./ImportDynamicCsvCard.vue?vue&type=template&id=0ff1bdd5&scoped=true"
import script from "./ImportDynamicCsvCard.vue?vue&type=script&lang=js"
export * from "./ImportDynamicCsvCard.vue?vue&type=script&lang=js"
import style0 from "./ImportDynamicCsvCard.vue?vue&type=style&index=0&id=0ff1bdd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1bdd5",
  null
  
)

export default component.exports